// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2BNBc","header":"MergedInvoice_header__3H0ZJ"};